import { initializeApp } from "firebase/app";
import { getDatabase, ref } from 'firebase/database';
import { getAuth ,signInWithEmailAndPassword } from 'firebase/auth';
import { useEffect, useState } from 'react';


// TODO: Replace the following with your app's Firebase project configuration
// See: https://firebase.google.com/docs/web/learn-more#config-object
const firebaseConfig = {
  // ...
  // The value of `databaseURL` depends on the location of the database
  databaseURL: "https://transforme-f9621-default-rtdb.asia-southeast1.firebasedatabase.app",
  apiKey: "AIzaSyAtVE4uYeqe0lYvfsk5C7oa6pd9E4Qp0L4"
};

const useAuth = () => {
  const [currentUser, setCurrentUser] = useState(null);

  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = auth.onAuthStateChanged((user) => {
      setCurrentUser(user);
    });

    return () => unsubscribe();
  }, []);

  return { currentUser };
};

const handleLogin = async (email, password) => {
  try {
    const userCredential = await signInWithEmailAndPassword(auth, email, password);
    const user = userCredential.user;

    // Signed in successfully
    console.log('User signed in:', user);
  } catch (error) {
    const errorCode = error.code;
    const errorMessage = error.message;
    console.error('Error logging in:', errorCode, errorMessage);
  }
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);


// Initialize Realtime Database and get a reference to the service
const database = getDatabase(app);
const auth = getAuth(app);

export { database ,auth,handleLogin,ref,useAuth};
